export default "__VITE_PUBLIC_ASSET__0123e794__"